<template>
  <div class="solutionCase">
    <top-nav></top-nav>
    <banner :bgImage="bgImage"></banner>
    <section class="clientVoice">
      <div class="solutionCaseBox" style="padding-bottom: 0">
        <div class="solutionConceptBox">
          <div class="solutionConceptBoxR">
            <img src="../../../static/images/clientConceptPic2.jpg" />
          </div>
          <div class="solutionConceptBoxL clientCaseBlue">
            <div class="solutionConceptIn">
              <div class="solutionConceptInTit">用心聆听客户的声音</div>
              <div class="solutionConceptInConn">
                我们的城市管理需求非常地多样化，所以我们尝试引入基于下一代互联网的车联网管理技术。这是一个新课题,
                睿哲科技的设备及解决方案成功地帮助我们解决了各平台数据互通共享的难题。
                <p>——某市信息化管理局</p>
              </div>
            </div>
            <div class="clientCaseArr"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="clientIncome">
      <div class="solutionCaseBox">
        <div class="solutionCaseTit clientCaseFont">
          注重客户收益，想客户之所想
        </div>
        <ul class="solutionIncomeFlex">
          <li>
            <img src="../../../static/images/solutionDetailIcon12.png" />
            <div class="solutionIncomeConn">
              通过IPV6车载终端的推广，开启<br />北斗卫星导航民用产业化示范项目
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionDetailIcon05.png" />
            <div class="solutionIncomeConn">
              通过建设车联网支撑平台，<br />实现当前局势下维稳的迫切需求
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionDetailIcon07.png" />
            <div class="solutionIncomeConn">
              建设IPV6车联网产业链生态<br />环境，促进并带动区域经济发展
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="clientChallenge">
      <div class="clientChallengeBox">
        <img src="../../../static/images/clientChallengeBg1.jpg" />
        <div class="clientChallengeConn">
          <div class="clientChallengeTit">直面挑战，毫不畏惧</div>
          <ul class="clientChallengeList">
            <li>
              <span><i></i></span
              >解决IPv6协议在新兴的车联网及大数据平台上的兼容和应用
            </li>
            <li>
              <span><i></i></span>为城市管理及交通监控提供全面的技术支持
            </li>
            <li>
              <span><i></i></span
              >为车联网与公安、安全、交通、运管等部门数据交换接口提供<br />&nbsp;&nbsp;&nbsp;&nbsp;协议转换支撑
            </li>
            <li>
              <span><i></i></span
              >更新新兴的车联网及大数据平台上的兼容和应用，服务地方、<br />&nbsp;&nbsp;&nbsp;&nbsp;油田、运输企业的智能管理
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="clientSolution">
      <div class="solutionCaseBox">
        <div class="solutionCaseTit clientCaseFont">
          成熟的解决方案，难题迎刃而解
        </div>
        <ul class="solutionIncomeFlex">
          <li>
            <div class="clientSolutionTit">双向数据交换平台</div>
            <div class="clientSolutionConn">
              建设支持双向的IPv4/IPv6数据交换平台，帮助车联网及相关系统向IPv4/IPv6用户提供访问服务，为车联网服务发布系统提供双栈发布
            </div>
          </li>
          <li>
            <div class="clientSolutionTit">建设运营支撑平台</div>
            <div class="clientSolutionConn">
              建设运营支撑平台，为IPv4/IPv6数据交换平台提供图形化的服务开通、设备管理和数据分析等功能
            </div>
          </li>
          <li>
            <div class="clientSolutionTit">建设用户溯源系统</div>
            <div class="clientSolutionConn">
              建设用户溯源系统，负责提供用户访问网站和应用系统的日志信息，包括时间、时长、源/目的IP地址和端口，被访问的URL，回溯查询用户信息等信息记录系统
            </div>
          </li>
        </ul>
      </div>
    </section>
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "solutionCase",
  data() {
    return {
      bgImage: "../../../static/images/clientDetailBanner.jpg?0219",
      showMask: false,
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";
@import "./case";
.solutionCase {
}
</style>



// WEBPACK FOOTER //
// src/pages/case/caseDetail2.vue